/** @jsxImportSource @emotion/react */

import Button from '@mui/material/Button'
import pick from 'lodash/pick'
import React, { useState } from 'react'
import { findOneUser_findOneUser as User } from '../../__generatedTypes__/findOneUser'
import ConfirmationModal from '../Modals/ConfirmationModal'
import * as classes from './styles'
import { useImpersonateUser } from './ImpersonateContext'

type Props = {
  user: User
}

export const ImpersonateButton = ({ user }: Props) => {
  const { impersonateUser, changeImpersonateUser, openWebPage } = useImpersonateUser()
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)

  if (impersonateUser?.id === user.id) {
    return (
      <Button css={classes.button} onClick={() => changeImpersonateUser(null)} size="small" color="red">
        Impersonate
      </Button>
    )
  }

  return (
    <>
      <Button css={classes.button} onClick={() => setIsConfirmationOpen(true)} size="small" color="blue">
        Impersonate
      </Button>
      <ConfirmationModal
        open={isConfirmationOpen}
        title="Impersonate feature"
        subtitle="Are you sure you want to switch views to see this person’s account?"
        onClose={() => setIsConfirmationOpen(false)}
        onConfirm={() => {
          changeImpersonateUser(pick(user, ['id', 'email', 'firstName', 'lastName', 'role']))
          setIsConfirmationOpen(false)
          openWebPage()
        }}
        confirmText="Yes, switch views"
        closeText="Cancel"
        isBlueConfirm
      />
    </>
  )
}
